import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { userData } from '../../Redux/Slices/adminPortalSlice';
import ReactLoading from 'react-loading';

function UserLogs() {
    let userDetails = useSelector(userData);
    if (userDetails === 'unloaded') {
        return (
            <div className="EpisodeAnalysis_loadingDiv">
                <ReactLoading type={'bubbles'} color={'#00695f'} height={100} width={100} />
            </div>
        )
    } else {
        return (
            <div>
                <table className="table table-striped">
                    <thead className="thead-dark">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Login Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userDetails.userDetails.map(function (data, index) {
                            return (
                                <tr key={index}>
                                    <td scope="row">{index+1}</td>
                                    <td>{data.name}</td>
                                    <td>{data.email}</td>
                                    <td>{`${data.time}`}</td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            </div>
        )
    }
}
export default UserLogs;